import React from 'react'
import { Link } from 'react-router-dom'

import subscription from "../../img/icons/subscription.png"
import Notification from "../../img/Notification.png"

export default function Subscription({className=""}) {
  return (
    <div className={`col-12 ${className}`}>
        <div className="common-box cb-subscription-bx pe-1">     
        <svg className='csb-notification' width="90" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="40" height="40" rx="20" fill="#221E42"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.021 12.6707C15.9599 12.6707 12.6713 15.9541 12.6713 20.0002C12.6713 24.0463 15.9599 27.3297 20.021 27.3297C23.0347 27.3297 25.6254 25.5209 26.7598 22.931L28.2517 23.5845C26.8665 26.7472 23.7028 28.9585 20.021 28.9585C15.0642 28.9585 11.0425 24.9497 11.0425 20.0002C11.0425 15.0508 15.0642 11.0419 20.021 11.0419C24.6754 11.0419 28.5043 14.5758 28.9551 19.1052C28.9825 19.3799 28.8688 19.6497 28.6531 19.8221C28.4374 19.9944 28.1491 20.0457 27.8872 19.9584L25.444 19.144L25.9591 17.5988L27.0866 17.9746C26.2057 14.9131 23.3766 12.6707 20.021 12.6707Z" fill="#35F8F8"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0007 15.6252C18.735 15.6252 17.709 16.6513 17.709 17.9169V18.5419H16.459V24.3752H23.5423V18.5419H22.2923V17.9169C22.2923 16.6513 21.2663 15.6252 20.0007 15.6252ZM18.959 17.9169V18.5419H21.0423V17.9169C21.0423 17.3416 20.5759 16.8752 20.0007 16.8752C19.4254 16.8752 18.959 17.3416 18.959 17.9169Z" fill="#35F8F8"/>
        </svg>  

          <div className='csb-data ms-2'>
            <div className="common-box-heading mb-1">Unlock Your Exclusive Access Today!</div>
            <div className="common-box-text">Don’t miss out! Start now to access premium features and take control of your journey. Join thousands who’ve already upgraded and are enjoying full benefits!</div>
              <Link to="/new-challenge" className="common-btn cb-fill mt-3"><span>Buy Challenge</span></Link>
          </div>
          {/* <img className="csb-img" src={subscription} alt="" /> */}
        </div>
    </div>
  )
}
